var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"overflow-x-auto"},[_c('div',{staticClass:"sparkline-sheet",staticStyle:{"height":"45vh"},attrs:{"id":"chartBarBox"}})])}
var staticRenderFns = []

export { render, staticRenderFns }